//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { openWordStudy } from '@/utils/openWordStudy'
export default {
  data () { return { words: [], rootId: null, root: null } },
  created () {
    this.$ajax.get(this.$api.etTreeDetail + '?id=' + this.$route.query.id).then(r => {
      this.rootId = r.tree && r.tree.rootId
      this.root = r.root || null
      if (this.rootId) {
        this.$ajax.get(this.$api.etRootDetail + '?id=' + this.rootId).then(d => {
          this.words = d.words || []
          if (!this.root) this.root = d.root
        })
      }
    })
  },
  methods: {
    study (w) {
      openWordStudy(this.$router, w.wordText || w.word_text)
    },
    water (w) {
      this.$ajax.post(this.$api.etTreeWater, {
        tree_id: this.$route.query.id,
        root_word_id: w.id
      }).then(r => {
        this.$toast && this.$toast('+' + (r.points || 0) + ' 积分 · ' + (r.level_name || ''))
        this.$router.replace({ path: '/etDetail_display', query: { id: this.$route.query.id } })
      }).catch(e => { this.$toast && this.$toast(e.message || '失败') })
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/innovation/etymology-tree/water.vue